import { NSCard, NSFormGroup } from 'bricks';
import { UnitMixRentRollData } from 'views/InvestmentMemo/types';
import RenderIf from 'components/RenderIf/RenderIf';
import InvestmentMemoUnitMixTable from './InvestmentMemoUnitMixTable/InvestmentMemoUnitMixTable';
import RentRollTable from './RentRollTable/RentRollTable';

interface Props {
    unitMixRentRoll: UnitMixRentRollData | null;
}

const UnitMixRentRoll = ({ unitMixRentRoll }: Props) => (
    <RenderIf isTrue={unitMixRentRoll}>
        {unitMixRentRoll && (
            <NSFormGroup>
                <NSCard className="NSCard--level-3">
                    {unitMixRentRoll.data.type === 'unit-mix' && (
                        <InvestmentMemoUnitMixTable
                            unitMixes={unitMixRentRoll.data.value}
                            totals={unitMixRentRoll.data.totals}
                        />
                    )}
                    {unitMixRentRoll.data.type === 'rent-roll' && (
                        <RentRollTable
                            tenants={unitMixRentRoll.data.value}
                            totals={unitMixRentRoll.data.totals}
                            isDataCenter={unitMixRentRoll.data.isDataCenter}
                        />
                    )}
                    {unitMixRentRoll.data.type === 'unit-mix-rent-roll' && (
                        <>
                            <InvestmentMemoUnitMixTable
                                unitMixes={unitMixRentRoll.data.unitMix.value}
                                totals={unitMixRentRoll.data.unitMix.totals}
                            />
                            <RentRollTable
                                tenants={unitMixRentRoll.data.rentRoll.value}
                                totals={unitMixRentRoll.data.rentRoll.totals}
                            />
                        </>
                    )}
                </NSCard>
            </NSFormGroup>
        )}
    </RenderIf>
);

export default UnitMixRentRoll;
